import React from 'react';
import { createStyleSheet, useStyles } from 'react-native-unistyles'; import Tooltip from './Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';


function TooltipWrapper({ hovered, onTooltipHovered, tooltipText }: { hovered: boolean; onTooltipHovered?: (hovered: boolean) => void; tooltipText: string; }) {
    const { theme } = useStyles(stylesheet);
    React.useEffect(() => {
        onTooltipHovered?.(hovered);
    }, [hovered]);

    return (
        <Tooltip
            useSimpleBox
            style={{
                color: theme.colors.white['500'],
                padding: 16,
                borderRadius: 12,
                width: 150,
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
                background: theme.colors.neutral['500'],
            }}
            tooltipContent={tooltipText}
            tooltipDirection='right'
        >
            <FontAwesomeIcon
                icon={faCircleInfo as IconDefinition}
                fontSize={16}
                color={theme.colors.neutral['500']}
            />
        </Tooltip>
    );
}

const stylesheet = createStyleSheet(theme => ({
    inputContainer: {
        minWidth: 200,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5
    },

    filterText: {
        color: theme.colors.labelColor,
        fontSize: 16,
        height: 25,
    },
    checkbox: {
        width: 20,
        height: 20
    }
}));
export default TooltipWrapper;
